module.exports = __webpack_public_path__ + "img/green_pin.png";